import React, { useState } from "react";
import { crearMembresia } from "../firebase/membresias";
import { useAuth } from "../contextos/AuthContext";
import { useEffect } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";

const Membresias = () => {
  const { usuario } = useAuth();
  useEffect(() => {
    const cargar = async () => {
      if (!usuario) return;
  
      const q = query(
        collection(db, "membresias"),
        where("pagadorId", "==", usuario.uid)
      );
  
      const snap = await getDocs(q);
  
      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
  
      setMisMembresias(data);
    };
  
    cargar();
  }, [usuario]);
  const [planId, setPlanId] = useState("");
  const [misMembresias, setMisMembresias] = useState([]);
  const [paraMi,
    setParaMi] =
    useState(false);

  const crear = async () => {
    try {
      const resultado = await crearMembresia({
        pagadorId: usuario.uid,
        planId
      });
  
      if (!resultado) {
        alert("Error creando membresía ❌");
        return;
      }
  
      const { id, token } = resultado;
  
      const link =
  `${window.location.origin}/activar-membresia/${token}`;

if (paraMi) {

  window.location.href = link;

  return;
}

alert("Membresía creada 🔥");

console.log("LINK PARA COMPARTIR:");
console.log(link);
  
      // 🔥 ACTUALIZAR UI (AQUÍ VA, NO AFUERA)
      setMisMembresias(prev => [
        ...prev,
        {
          id,
          token,
          planId,
          asignada: false,
          estadoPago: "en_verificacion"
        }
      ]);
  
    } catch (error) {
      console.error(error);
      alert("Error creando membresía ❌");
    }
  };
  
  const [planes, setPlanes] =
	useState([]);

  useEffect(() => {

    const cargarPlanes = async () => {
  
      const snap = await getDocs(
        collection(db, "planes")
      );
  
      const activos =
  snap.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data()
    }))
    .filter(
      (plan) =>
        plan.activo === true
    )
    .sort(
      (a, b) =>
        (a.orden || 999) -
        (b.orden || 999)
    );
  
      setPlanes(activos);
  
      if (activos.length > 0) {
  
        setPlanId(activos[0].id);
      }
    };
  
    cargarPlanes();
  
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>

🎓 Patrocina un estudiante

</h2>

<p
style={{
  opacity: 0.8,
  maxWidth: "600px"
}}
>

Ayuda a un estudiante a prepararse para sus exámenes
y alcanzar sus metas académicas.

</p>

      

      <div
  style={{
    display: "flex",
    gap: "1rem",
    marginTop: "1rem",
    flexWrap: "wrap"
  }}
>

  {planes.map((plan) => (

    <div

      key={plan.id}

      onClick={() =>
        setPlanId(plan.id)
      }

      style={{

        cursor: "pointer",

        width: "280px",

        padding: "1rem",

        borderRadius: "16px",

        border:
          planId === plan.id
            ? "3px solid #60a5fa"
            : "1px solid rgba(255,255,255,0.1)",

        background:
          plan.destacado
            ? "rgba(96,165,250,0.15)"
            : "rgba(255,255,255,0.05)"
      }}
    >

      {plan.destacado && (

        <div
          style={{
            marginBottom: "0.5rem"
          }}
        >

          ⭐ MÁS POPULAR
          <p
  style={{
    color: "#facc15",
    fontWeight: "bold"
  }}
>

  Mejor valor por mes

</p>
        </div>

        
      )}

      <h3>

        {plan.nombre}

      </h3>

      <h2>

        $
        {(plan.precio || 0)
          .toLocaleString(
            "es-CO"
          )}

      </h2>
      <div
  style={{
    fontSize: "0.85rem",
    marginTop: "0.75rem"
  }}
  dangerouslySetInnerHTML={{
    __html:
      plan.descripcionHtml || ""
  }}
/>

</div>

      

  ))}

</div>


      
      <br /><br />

      <div
  style={{
    marginTop: "1rem",
    marginBottom: "1rem"
  }}
>

  <label>

    <input
      type="checkbox"
      checked={paraMi}
      onChange={(e) =>
        setParaMi(
          e.target.checked
        )
      }
    />

    {" "}
    Esta membresía es para mí

  </label>

</div>

      <button onClick={crear}>
      🎓 Patrocinar estudiante
      </button>
      
      <h3>

  📚 Estudiantes patrocinados

</h3>

      {misMembresias.map((m) => (
        <div key={m.id} style={{
          border: "1px solid #ccc",
          padding: "10px",
          marginBottom: "10px",
          borderRadius: "10px"
        }}>
          <p><strong>Plan:</strong> {m.planId}</p>

          <p>
            <strong>Estado:</strong>{" "}
            {m.asignada ? "🟢 Estudiante activo" : "🟡 Pendiente de activación"}
          </p>


          {!m.asignada && (
            <p style={{ color: "orange" }}>
              🔗 Pendiente de activar
            </p>
          )}

          {m.asignada && (
            <p style={{ color: "green" }}>
              👤 Asignada a: {m.estudianteId}
            </p>
          )}

          {!m.asignada && (
            <div>
              <p style={{ color: "orange" }}>
                🔗 Pendiente de activar
              </p>

              <button
                onClick={() => {
                  const link = `${window.location.origin}/activar-membresia/${m.token}`;
                  navigator.clipboard.writeText(link);
                  alert("Link copiado al portapapeles 🚀");
                }}
              >
                Copiar link
              </button>

              <button
  style={{
    marginLeft: "10px"
  }}
  onClick={() => {

    const link =
      `${window.location.origin}/activar-membresia/${m.token}`;

    const mensaje =
`🎁 Te han regalado acceso a Yutake

Prepárate para alcanzar tus metas académicas con simulacros, preguntas y seguimiento de progreso.

Activa tu acceso aquí:

${link}

🚀 ¡Muchos éxitos!`;

    const url =
      `https://wa.me/?text=${encodeURIComponent(mensaje)}`;

    window.open(
      url,
      "_blank"
    );
  }}
>
  📲 WhatsApp
</button>

              <p style={{ fontSize: "12px", marginTop: "5px" }}>
                {window.location.origin}/activar-membresia/{m.token}
              </p>
            </div>
          )}
        </div>
      ))}

    </div>
  );
};

export default Membresias;